export enum GenereteWorkOrderByInvoiceSituation {
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Denied = 'DENIED',
  InTyping = 'IN_TYPING',
  Processing = 'PROCESSING',
  ProcessingCancellation = 'PROCESSING_CANCELLATION',
  Replaced = 'REPLACED',
  Validated = 'VALIDATED',
}

export enum GenereteWorkOrderByInvoiceType {
  NFE = 'NFE',
  NFC = 'NFC',
  NFS = 'NFS',
}

export enum GenereteWorkOrderByInvoiceDateType {
  EntryDate = 'ENTRY_DATE',
  ClosingDate = 'CLOSING_DATE',
  AuthorizationDate = 'AUTHORIZATION_DATE',
}

export enum GenereteWorkOrderSituation {
  Open = 'OPEN',
  Authorized = 'AUTHORIZED',
  Closed = 'CLOSED',
  Canceled = 'CANCELED',
}
